<template>
    <div>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            O Drive ainda não foi iniciado. Deseja iniciar?
            <v-select
                :no-data-text="noDataAvailable"
                v-model="initData.idCredential"
                item-value="id"
                item-text="name"
                :items="driveCredentials"
                label="Código da Storage"
                :rules="[v => !!v || 'Código da Storage é obrigatória']"
                required
            ></v-select>
            <v-select
                :no-data-text="noDataAvailable"
                v-model="initData.idTemplate"
                item-value="id"
                item-text="name"
                :items="driveTemplates"
                label="Template de Pasta"
                :rules="[v => !!v || 'Template de Pasta é obrigatório']"
                required
            ></v-select>
            <v-select
                :no-data-text="noDataAvailable"
                v-model="initData.generalRuleGroupBackofficeID"
                item-value="id"
                item-text="name"
                value="initData.generalRuleGroupBackofficeID"
                :items="ruleDriveGroupsBackoffice"
                label="Grupo de Regras de Backoffice"
                :rules="[v => !!v || 'Grupo de Regras de Backoffice é obrigatório']"
                required
            ></v-select>
            <v-select
                :no-data-text="noDataAvailable"
                v-model="initData.generalRuleGroupCompanyID"
                item-value="id"
                item-text="name"
                :items="ruleDriveGroupsCompany"
                label="Grupo de Regras de Company"
                :rules="[v => !!v || 'Grupo de Regras de Company é obrigatório']"
                required
            ></v-select>
            <v-text-field
                v-model="initData.path"
                label="Endereço do Drive"
                :rules="[v => !!v || 'Endereço do Drive é obrigatório']"
                required
            ></v-text-field>

            <v-btn
                :disabled="sending"
                color="initButton"
                class="white--text text-capitalize"
                @click="initClick"
            >
                Iniciar
            </v-btn>
        </v-form>
        <v-snackbar
          top
          timeout="20000"
          multi-line
          v-model="snackbar"
        >
          {{ snackbartext }}
          <v-btn text @click.native="snackbar = false">Fechar</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import {
  getCredentials, getTemplates, initDrive, getRuleDriveGroups,
} from '@/common/driveserver';

const BACKOFFICE = 'BACKOFFICE';
const COMPANY = 'COMPANY';
export default {
  name: 'Init',
  data: () => ({
    snackbartext: '',
    snackbar: false,
    valid: true,
    sending: false,
    credentialValid: true,
    templateValid: true,
    pathValid: true,
    driveCredentials: [],
    driveTemplates: [],
    ruleDriveGroupsBackoffice: [],
    ruleDriveGroupsCompany: [],
    initData: {
      idCredential: null,
      idTemplate: null,
      path: '',
      generalRuleGroupBackofficeID: null,
      generalRuleGroupCompanyID: null,
    },
    noDataAvailable: 'Nenhum dado encontrado',
  }),
  async beforeCreate() {
    getCredentials()
      .then((response) => {
        this.driveCredentials = response.data;
      });
    getTemplates()
      .then((response) => {
        this.driveTemplates = response.data;
      });
    getRuleDriveGroups(BACKOFFICE)
      .then((response) => {
        this.ruleDriveGroupsBackoffice = response.data;
        let defaultRuleGroupBackoffice = null;
        [defaultRuleGroupBackoffice] = this.ruleDriveGroupsBackoffice.filter((group) => group.defaults);
        this.initData.generalRuleGroupBackofficeID = defaultRuleGroupBackoffice?.id;
      });
    getRuleDriveGroups(COMPANY)
      .then((response) => {
        this.ruleDriveGroupsCompany = response.data;
        let defaultRuleGroupCompany = null;
        [defaultRuleGroupCompany] = this.ruleDriveGroupsCompany.filter((group) => group.defaults);
        this.initData.generalRuleGroupCompanyID = defaultRuleGroupCompany?.id;
      });
  },
  methods: {
    initClick() {
      if (this.$refs.form.validate()) {
        this.sending = true;
        initDrive(this.initData)
          .then((response) => {
            this.sending = false;
            this.driveCredentials = response.data;
            this.snackbar = true;
            this.snackbartext = 'Criado com sucesso! ';
            this.$router.push({
              name: 'drive-init',
            });
          })
          .catch((error) => {
            this.sending = false;
            this.snackbar = true;
            this.snackbartext = `Ocorreu um erro ao iniciar o drive! ${error.response.data} `;
          });
      }
    },
  },
};
</script>
